import type { FaireProductEntity } from "../../entity_types/product";

export const p_h297mzz26z: FaireProductEntity = {
  token: "p_h297mzz26z",
  type: "product",
  name: "Assortment of Lavender Eye Pillows",
  brandToken: "b_5qsb0hdt",
  brandName: "Belle's Nest",
  imageUrl:
    "https://cdn.faire.com/fastly/7c0c05d6ec04c59761352847b33b8c7f526257d9669933546db5c358f1b61ae9.jpeg",
  galleryImageUrls: [],
  priceDollars: 22.5,
  description:
    "Assortment of Lavender Eye Pillows\n\nOuter cover is washable which will provide you with a clean and relaxing experience each time you use it. Hand wash cold/lay to dry.\nYou will receive assorted colors. \n\n\nThese make for a colorful display!\n\nExperience calm, serenity and comfort while resting with this beautiful and soothing eye pillow.\n\nFilling: French Lavender and rice.\n\nCotton fabric\n\n*photo is a sampling, not what you will receive although they will be just as beautiful!",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:44.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
